import { AccessUnversionedObjectCertificateRecipe, AccessUnversionedObjectCertificateReverseMap } from './AccessUnversionedObjectCertificate.js';
import { AccessVersionedObjectCertificateRecipe, AccessVersionedObjectCertificateReverseMap } from './AccessVersionedObjectCertificate.js';
import { AffirmationCertificateRecipe, AffirmationCertificateReverseMap } from './AffirmationCertificate.js';
import { LicenseRecipe, LicenseReverseMap } from './License.js';
import { RelationCertificateRecipe, RelationCertificateReverseMap } from './RelationCertificate.js';
import { RightToDeclareTrustedKeysForEverybodyCertificateRecipe, RightToDeclareTrustedKeysForEverybodyCertificateReverseMap } from './RightToDeclareTrustedKeysForEverybodyCertificate.js';
import { RightToDeclareTrustedKeysForSelfCertificateRecipe, RightToDeclareTrustedKeysForSelfCertificateReverseMap } from './RightToDeclareTrustedKeysForSelfCertificate.js';
import { TrustKeysCertificateRecipe, TrustKeysCertificateReverseMap } from './TrustKeysCertificate.js';
export const CertificateReverseMaps = [
    AccessUnversionedObjectCertificateReverseMap,
    AccessVersionedObjectCertificateReverseMap,
    AffirmationCertificateReverseMap,
    LicenseReverseMap,
    RelationCertificateReverseMap,
    RightToDeclareTrustedKeysForEverybodyCertificateReverseMap,
    RightToDeclareTrustedKeysForSelfCertificateReverseMap,
    TrustKeysCertificateReverseMap
];
const Certificates = [
    AccessUnversionedObjectCertificateRecipe,
    AccessVersionedObjectCertificateRecipe,
    AffirmationCertificateRecipe,
    LicenseRecipe,
    RelationCertificateRecipe,
    RightToDeclareTrustedKeysForEverybodyCertificateRecipe,
    RightToDeclareTrustedKeysForSelfCertificateRecipe,
    TrustKeysCertificateRecipe
];
export default Certificates;
//# sourceMappingURL=CertificateRecipes.js.map